<template>
  <a-tooltip
    v-bind="filteredProps"
    :arrowPointAtCenter="arrowPointAtCenter"
    color="#ffffff"
  >
    <!-- 同时支持属性和插槽 -->
    <template #title>
      <div v-if="hasContentSlot" class="custom-tooltip">
        <slot name="content"></slot>
      </div>  
      <div v-else-if="content" class="custom-tooltip">  
        <component :is="iconView" v-if="showIcon" :style="{color: iconColor}" class="icon-component"/>
        <span>{{content}}</span>
      </div>
    </template>
    <slot></slot>
  </a-tooltip>
</template>

<script lang="ts" setup>
import { computed, useAttrs, useSlots } from 'vue';
import { ExclamationCircleFilled, CheckCircleFilled, CloseCircleFilled, InfoCircleFilled } from "@ant-design/icons-vue";

const slots = useSlots();

interface TooltipProps {
  content?: string;
  showIcon?: boolean;
  iconType?: 'error' | 'success' | 'info' | 'warning';
  arrowPointAtCenter?: boolean;
}

const props = withDefaults(defineProps<TooltipProps>(), {
  content: '',
  showIcon: false,
  iconType: 'warning',
  arrowPointAtCenter: true,
});

const iconMap = {
  error: {
    comp: CloseCircleFilled,
    color: '#ff4d4f',
  },
  success: {
    comp: CheckCircleFilled,
    color: '#52C41A',
  },
  info: {
    comp: InfoCircleFilled,
    color: '#1890ff',
  },
  warning: {
    comp: ExclamationCircleFilled,
    color: '#F4A21F',
  }
}

const iconView = computed(() => {
  return iconMap[props.iconType]?.comp ?? iconMap.warning.comp;
})

const iconColor = computed(() => {
  return iconMap[props.iconType]?.color ?? iconMap.warning.color;
})


// 判断是否存在content插槽
const hasContentSlot = computed(() => !!slots.content);

const attrs = useAttrs();

// 合并属性并过滤掉自定义属性
const filteredProps = computed(() => {
  const { ...rest } = props;
  return { ...rest, ...attrs };
});
</script>

<style lang="less" scoped>
.custom-tooltip {
  max-width: 100%;
  color: #595959; 
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
  white-space: pre-wrap;
  max-height: 170px;
  overflow-y: auto;
}

.icon-component {
  margin-right: 8px; 
}

</style>